import { notifications } from '@/lib/firestore'

import * as Types from './types'

export default {
  /**
   * @param {Object} vuex
   * @param {VvNotification} notification
   */
  async [Types.REGISTER_NOTIFICATION]({ commit }, notification) {
    commit(Types.ADD_NOTIFICATION, notification)

    await notifications.set(notification.id, notification)
  },
  async [Types.NOTIFICATION_SEEN]({ commit }, notificationId) {
    commit(Types.SET_NOTIFICATION_SEEN, notificationId)

    await notifications.set(notificationId, { seen: true })
  },
  async [Types.NOTIFICATION_TOASTED]({ commit }, notificationId) {
    commit(Types.SET_NOTIFICATION_TOASTED, notificationId)

    await notifications.set(notificationId, { toast: { shown: true } })
  }
}
